import React from 'react';
import styled from 'styled-components';

interface FilterProps {
  className?: string;
  fill: string;
  imageSrc: string;
  maskSrc: string;
}

export default function ImageFilter({
  className,
  fill = '#EDA064',
  imageSrc = `https://media.development.trac.co/merch/images/49-368.jpg`,
  maskSrc = '/sweater.png',
}: FilterProps) {
  return (
    <FilterWrapper className={className || ''} fill={fill}>
      <img id="main-image" src={imageSrc} alt="filter-main" />
      {fill !== 'white' && (
        <img id="mask-image" src={maskSrc} alt="filter-mask" />
      )}
    </FilterWrapper>
  );
}

interface FilterWraperInterface {
  fill: string;
}

const FilterWrapper = styled.div`
  position: relative;

  *,
  #mask-image,
  #main-image {
    width: 100%;
    height: 100%;
  }

  #main-image {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  #mask-image {
    background-color: ${(props: FilterWraperInterface) => props.fill};
    mix-blend-mode: multiply;
    margin-bottom: -4px;
  }
`;
